<template>
  <div class="book-content"
    :class="{ pc: !isMobile, width67: isShowDigitalArticleView && currentEditHeader === 'catalog' }"
    @contextmenu.prevent="onMenuListShow" @click="closeMenuListShow">
    <img v-show="showJump" class="jump-btn" src="@imgs/left.png" @click="toPage('previous')" v-if="toPageBtnShow" />
    <TurnBook @onTurned="onTurned" @onTurnedXiaoYang="onTurnedXiaoYang"></TurnBook>
    <!-- <pdfview></pdfview> -->
    <img v-show="showJump" class="jump-btn" src="@imgs/right.png" @click="toPage('next')" v-if="toPageBtnShow" />
    <MenuList ref="menuList" v-if="!isMobile"></MenuList>
    <Explain ref="explain"></Explain>
    <PhoneHelp ref="phoneHelp"></PhoneHelp>
    <EpaperArticleDetail v-if="false"></EpaperArticleDetail>
    <DigitalArticleMenu ref="digitalArticleMenu" v-if="!isStaticBook & (currentEditHeader === 'catalog')"
      :width="isMobile ? '100%' : 300" :init-show="isShowDigitalArticleMenu" :init-page-index="pageIndex"
      :init-article-index="articleIndex" :articles="articles" @onChangeArticle="onChangeArticle"
      @onClose="onCloseArticleMenu"></DigitalArticleMenu>
    <DigitalArticleView v-if="!isStaticBook & (currentEditHeader === 'catalog')"
      :width="isMobile ? '100%' : '33%'" :init-show="isShowDigitalArticleView" :init-article-text="articleText"
      :init-show-prev-and-next="isPaper && bookData.readModel === 2" @onShare="onShareArticleView" :audio-src="audioSrc"
      @onClose="onCloseArticleView" @onPrev="onPrevArticleView" @onNext="onNextArticleView" ref="articleView">
    </DigitalArticleView>
  </div>
</template>

<script>
import MenuList from '@components/MenuList/index.vue'
import TurnBook from './turnBook.vue'
import { formatDigitalArticle } from '@/utils'
// import Pdfview from '@components/pdfview/pdfview'
import getBook from '@api/getBook'
import Explain from '@components/books/components/Help.vue'
import PhoneHelp from '@components/books/components/PhoneHelp.vue'
import EpaperArticleDetail from './components/EpaperArticleDetail.vue'
import mixin from './turnBookMixin'
import DigitalArticleView from '../digital/DigitalArticleView' // 小样
import DigitalArticleMenu from '../digital/DigitalArticleMenu' // 目录
import { mapState } from 'vuex'
export default {
  name: 'bookContent',
  mixins: [mixin],
  data() {
    return {
      timer: '',
      articles: [],
      pageIndex: 0,
      articleIndex: 0,
      articleXiaoYangId: 0,
      audioSrc: '', //离线小样文章音频
      articleTitle: '',
      articleText: '',
      openDigitalArticleMobile: true,
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0
      }
    }
  },
  computed: {
    ...mapState('book', ['totalPage', 'bookData']),
    isPaper() {
      return this.$store.state.book.isPaper
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    voiceNumber() {
      return this.$store.state.config.bookObj.voiceNumber
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    currentEditHeader() {
      return this.$store.state.edit.currentEditHeader
    },
    bookPath() {
      return this.$store.state.book.bookPath
    },
    toPageBtnShow() {
      const result = !this.isMobile && !(this.isEditDrawerShow || this.currentEditHeader !== 'catalog')
      return result
    },
    showJump() {
      let bookContent = $('#app')
      return bookContent.width() / (bookContent.height() - 80) > 1.4
    },
    isShowDigitalArticleMenu() {
      return this.$store.state.book.isShowDigitalArticleMenu
    },
    digitalArticleId() {
      return this.$store.state.book.digitalArticleId
    },
    isShowCommerHeader() {
      return this.$route.meta.requiresAuth === true && this.$store.state.book.isShowCommerHeader && !this.$store.state.common.isStaticBook
    },
    isShowDigitalArticleView() {
      return this.$store.state.book.isShowDigitalArticleView
    }
  },
  components: {
    DigitalArticleMenu,
    DigitalArticleView,
    TurnBook,
    // Pdfview,
    MenuList,
    Explain,
    PhoneHelp,
    EpaperArticleDetail,
  },
  mounted() {
    // 请求书刊详情
    const params = {
      id: this.$route.query.id
    }
    if (this.isPaper) {
      // 数字报获取小样目录
      // 从缓存中读取上一次的阅读的页数
      this.readingLog = JSON.parse(localStorage.getItem('readingLog')) || {}
      this.pageIndex = this.readingLog[this.$route.query.id] || 1
      // 导览文章列表
      if (this.bookData.catalog) {
        let catalog = JSON.parse(this.bookData.catalog)
        this.articles = (catalog ? this.processCatalogList(catalog.catalogList, this.bookData.displayPageNo) : []) || []
      } else {
        this.articles = []
      }
      console.log(this.articles, this.bookData)

      if (this.articles.length === 0) {
        this.isShowTab = false
      }
      this.getXiaoYangDetailInfo(this.getFirstArticleXiaoYangId(this.pageIndex))
      // 移动端时，如果存在目录之前是打开状态，则进入页面后尝试恢复目录之前的展示状态
      if (this.openDigitalArticleMobile && this.isMobile) {
        let isShowDigitalArticleMenu = sessionStorage.getItem('isShowDigitalArticleMenu_' + this.$route.query.id)
        let isShowDigitalArticleMenu_articleIndex = sessionStorage.getItem('isShowDigitalArticleMenu_articleIndex')
        if (isShowDigitalArticleMenu === 'true') {
          if (isShowDigitalArticleMenu_articleIndex) {
            this.articleIndex = parseInt(isShowDigitalArticleMenu_articleIndex)
          }
          this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_MENU', true)
          setTimeout(() => {
            let menuBox = this.$refs.digitalArticleMenu.$el.getElementsByClassName('box')[0]
            let menuItems = this.$refs.digitalArticleMenu.$el.getElementsByClassName('item')
            for (let a in menuItems) {
              if (menuItems.hasOwnProperty(a) && parseInt(this.pageIndex) === parseInt(a) + 1) {
                menuBox.scrollTop = menuItems[a].offsetTop
              }
            }
          }, 100)
        }
      }
    }
  },
  watch: {
    digitalArticleId(val) {
      if (val && !this.isPaper && !this.isMobile) {
        this.getXiaoYangDetailInfo(val)
      }
    }
  },
  methods: {
    shareBook(link, poster, posterPic, title) {
      this.$refs.shareBookMsg.dialogVisible = true
      this.$store.commit('config/UPDATE_POSTERBG', posterPic)
      this.$store.commit('config/UPDATE_POSTER', poster)
      this.qrObj.value = link
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.isShowPoster = poster
      this.qrObj.title = title
    },
    // 书刊部分展示时，删除冗余页码目录
    processCatalogList(catalog, displayPageNo) {
      if (displayPageNo === 0 || !catalog) {
        return catalog
      }

      function deleteNode(arr) {
        let list = arr
        for (let i = 0; i < list.length;) {
          if (list[i].page > displayPageNo) {
            list.splice(i, 1)
          } else if (list[i].children && list[i].children.length > 0) {
            deleteNode(list[i].children)
            i++
          } else {
            i++
          }
        }
      }

      deleteNode(catalog)
      return catalog
    },
    /**
     * 获取书箱明细数据
     * @param params
     * @param callback
     */
    getBookDetails(params, callback) {
      let url = this.isPaper ? getBook.GetPaperDetails : getBook.GetMobileBookDetails
      url(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    getFirstArticleXiaoYangId(pageIndex) {
      this.articleIndex = 1
      if (this.articles[pageIndex - 1]?.children) {
        return this.articles[pageIndex - 1]?.children[0]?.xiaoYangId || 0
      } else {
        return 0
      }
    },
    getXiaoYangDetail(xiaoYangId, callback) {
      // 根据小样ID获取内容详情
      let daYangList = staticOptions.daYangList
      let detail
      for (const daYang of daYangList) {
        if (detail) {
          break
        }
        for (const xiaoYang of daYang.xiaoYangList) {
          if (xiaoYang.id === xiaoYangId) {
            detail = xiaoYang
            break
          }
        }
      }
      if (detail) {
        callback && callback(formatDigitalArticle({
          data: {
            data: detail
          }
        }).data.data)
      }
    },
    getXiaoYangDetailInfo(xiaoYangId) {
      if (xiaoYangId) {
        this.getXiaoYangDetail(xiaoYangId, (data) => {
          this.articleXiaoYangId = xiaoYangId
          this.articleTitle = data.title
          this.articleText = data.content
          this.audioSrc = data.audio
          this.$refs.articleView.articleId = this.articleXiaoYangId
          this.$refs.articleView.title = data.title
          this.$refs.articleView.creator = data.creator
        })
      }
    },
    repairAlert() {
      // 移动端时需要修复一下弹窗的层级问题
      if (this.isMobile) {
        setTimeout(() => {
          for (let a in document.body.children) {
            if (document.body.children.hasOwnProperty(a)) {
              let tabindex = parseInt(document.body.children[a].getAttribute('tabindex'))
              let className = document.body.children[a].className
              if (className.indexOf('el-message-box__wrapper') >= 0 && tabindex === -1) {
                document.body.children[a].style.zIndex = 10000
              } else if (className.indexOf('v-modal') >= 0 && tabindex === 0) {
                document.body.children[a].style.zIndex = 9999
              }
            }
          }
        }, 100)
      }
    },
    // 左键菜单框消失
    closeMenuListShow() {
      if (!this.isMobile) {
        this.$refs.menuList.isMenuShow = false
      }
    },
    //点击书刊区域鼠标右键菜单修改为> “放大”“缩小”“全屏”快捷操作父元素显示
    onMenuListShow(ev) {
      let MenuLists = this.$refs.menuList
      if (MenuLists) {
        MenuLists.isMenuShow = !MenuLists.isMenuShow
        var oEvent = ev
        let pxs1 = oEvent.clientX + 'px'
        let pxs2 = oEvent.clientY - 122 + 'px'
        this.$nextTick(() => {
          $('.menu-list').css({ left: `${pxs1}` })
          $('.menu-list').css({ top: `${pxs2}` })
        })
      }
    },
    onChangeArticle(page, article, pageIndex, articleIndex, optype) {
      this.pageIndex = pageIndex
      this.articleIndex = articleIndex
      $('#book').turn('page', pageIndex)
      if (optype === 1) {
        if (this.isMobile) {
          this.onCloseArticleMenu()
        }
      } else if (optype === 2) {
        if (article && article.xiaoYangId) {
          if (this.openDigitalArticleMobile && this.isMobile) {
            // 如果是移动端，则保存一下文章的索引
            sessionStorage.setItem('isShowDigitalArticleMenu_articleIndex', articleIndex)
            // 微信下则跳转至新的页面
            window.location.href = window.location.origin + window.location.pathname + '#/digitalArticleMobile?id=' + article.xiaoYangId
          } else {
            this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
            this.getXiaoYangDetailInfo(article.xiaoYangId)
          }
        }
      }
    },
    onCloseArticleMenu() {
      this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_MENU', !this.isShowDigitalArticleMenu)
      this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
      if (this.openDigitalArticleMobile && this.isMobile) {
        // 如果是移动端，则保存一下目录的打开状态
        sessionStorage.setItem('isShowDigitalArticleMenu_' + this.$route.query.id, this.isShowDigitalArticleMenu)
      }
    },
    onShareArticleView() {
      this.shareBook(
        window.location.origin + window.location.pathname + '#/digitalArticle?id=' + this.articleXiaoYangId + '&voiceNumber=' + this.voiceNumber + '&type=' + (!this.isPaper ? 'book' : 'paper'),
        '',
        '',
        this.articleTitle
      )
    },
    onCloseArticleView() {
      this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', !this.isShowDigitalArticleView)
    },
    onPrevArticleView() {
      if (this.pageIndex === 1 && this.articleIndex === 1) {
        this.$alert('已经是第一篇文章', '提示', {
          confirmButtonText: '确定'
        })
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex - 1
      let xiaoYangId = this.articles[this.pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
      if (xiaoYangId === 0 && this.pageIndex === 1) {
        return
      }
      if (xiaoYangId === 0) {
        let pageIndex = this.pageIndex - 1
        articleIndex = this.articles[pageIndex - 1]?.children.length
        xiaoYangId = this.articles[pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
        if (xiaoYangId === 0) {
          return
        }
        this.pageIndex = pageIndex
        $('#book').turn('page', pageIndex)
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId)
    },
    onNextArticleView() {
      if (this.pageIndex === this.totalPage && this.articleIndex === this.articles[this.pageIndex - 1].children.length) {
        this.$alert('已经是最后一篇文章', '提示', {
          confirmButtonText: '确定'
        })
        this.repairAlert()
        return
      }
      let articleIndex = this.articleIndex + 1
      let xiaoYangId = this.articles[this.pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
      if (xiaoYangId === 0 && this.pageIndex === this.totalPage) {
        return
      }
      if (xiaoYangId === 0) {
        let pageIndex = this.pageIndex + 1
        articleIndex = 1
        xiaoYangId = this.articles[pageIndex - 1]?.children[articleIndex - 1]?.xiaoYangId || 0
        if (xiaoYangId === 0) {
          return
        }
        this.pageIndex = pageIndex
        $('#book').turn('page', pageIndex)
      }
      this.articleIndex = articleIndex
      this.getXiaoYangDetailInfo(xiaoYangId)
    },
    onTurned(page) {
      if (this.pageIndex === page) {
        return
      }
      this.pageIndex = page
      this.getXiaoYangDetailInfo(this.getFirstArticleXiaoYangId(page))
    },
    onTurnedXiaoYang(coordinate, page) {
      if (this.openDigitalArticleMobile && this.isMobile) {
        // 微信下则跳转至新的页面
        window.location.href = window.location.origin + window.location.pathname + '#/digitalArticleMobile?id=' + coordinate.xiaoyangid + '&type=' + (this.isPaper ? 'paper' : 'book')
      } else {
        this.pageIndex = page.index
        this.articleIndex = coordinate.xiaoyangindex
        this.getXiaoYangDetailInfo(coordinate.xiaoyangid)
        this.$store.commit('book/UPDATE_IS_SHOW_DIGITAL_ARTICLE_VIEW', true)
        // this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', this.isShowDigitalArticleMenu || this.isShowDigitalArticleView)
      }
    }
  }
}
</script>
<style lang="scss">
.book-content {
  padding: 40px 0;
  position: relative;

  &.pc {
    z-index: 1;
    padding-right: 5px;
    padding-left: 5px;
    &.width67 {
      width: 67%;
    }
  }
  .digital-article-view {
    position: fixed;
    top: 40px;
    height: calc(100% - 40px);
    padding-bottom: 40px;
    .login {
      display: none;
    }
    .collect {
      right: 90px;
      top: 0;
      margin-top: 12px;
    }
  }
  img {
    z-index: 1;
  }
  .jump-btn {
    cursor: pointer;
    width: 42px;
  }
}
</style>
